import { Autocomplete, Box, Chip, Divider, Grid2, styled } from "@mui/material";

export const ScreenshotContainer = styled(Box)`
  width: 100%;
  aspect-ratio: 1/1;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  overflow: hidden;
`;

export const MetadataGrid = styled(Grid2)`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Row = styled(Box)`
  display: flex;
  gap: 6px;
  align-items: ${({ center }) => (center ? "center" : undefined)};
  justify-content: ${({ spacebetween }) =>
    spacebetween ? "space-between" : undefined};
`;

export const TableWrapper = styled(Box)`
  height: 100%;
  padding-block-end: 12px;
`;

export const ScreenShot = styled("iframe")`
  border: none;
  height: 100vh;
  pointer-events: none;
  user-select: none;
  overflow: hidden;

  /* A full-viewport-tall preview swallows a phone screen — cap it. */
  @media (max-width: 768px) {
    height: 50vh;
  }
`;

export const DrawerWrapper = styled(Box)`
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100%;
  gap: 8px;
`;

export const ChipWrapper = styled(Box)`
  flex-wrap: wrap;
  display: flex;
  gap: 4px;
`;

export const TitleWrapper = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const LogoPreviewWrapper = styled(Box)`
  padding: 0;
  margin: 0;
  width: 100%;
  height: auto;
  object-fit: contain;
  border-radius: 8px;
  position: relative;
  cursor: pointer;

  &::before {
    content: "${({ content }) => content}";
    color: ${({ theme }) => theme.palette.text.secondary};
    background-color: ${({ theme }) => theme.palette.background.secondary};
    font-size: 12px;
    width: 60px;
    text-align: center;
    position: absolute;
    top: -10px;
    left: 8px;
  }
`;

export const LogoPreview = styled("img")`
  padding: 8px;
  width: 100%;
  height: auto;
  max-height: 200px;
  object-fit: contain;
  border-radius: 12px;
  border: 2px solid ${({ theme }) => theme.palette.divider};
`;

export const ScrollableSection = styled(MetadataGrid)`
  height: 100%;
  overflow-y: auto;
  gap: 16px;
`;

export const ContentGrid = styled(Grid2)`
  height: min-content;
`;

export const SpacedChip = styled(Chip)`
  margin-inline-end: 6px;
`;

export const SectionDivider = styled(Divider)`
  margin-block: 12px;
`;

export const StyledAutocomplete = styled(Autocomplete)`
  width: 200px;
  max-width: 100%;
`;
